function expandErrorToErrors(error: any): Error[] {
	// Error from createDataFetcherForSuspense might have nested errors
	const errors: Error[] = [error];
	if (Array.isArray(error.otherErrors)) {
		errors.push(...error.otherErrors);
	}
	delete error.otherErrors;
	return errors;
}

/**
 * Wait for all preload tasks to settle.
 * @returns void if successful, or an array of errors if failed.
 */
export async function waitForAllReturnWhenError<T>(
	values: T | T[],
): Promise<void | Error[] | Awaited<T>[]> {
	if (!Array.isArray(values)) {
		values = [values];
	}
	return Promise.allSettled(values).then((results) => {
		const errors = [] as Error[];
		for (const result of results) {
			if (result.status === 'rejected') {
				errors.push(...expandErrorToErrors(result.reason));
			} else if (result.status === 'fulfilled') {
				const fulfilledValue = result.value;
				if (fulfilledValue instanceof Error) {
					errors.push(...expandErrorToErrors(fulfilledValue));
				} else if (Array.isArray(fulfilledValue)) {
					const filteredErrors = fulfilledValue.filter(
						(value): value is Error => value instanceof Error,
					);
					errors.push(...filteredErrors.flatMap(expandErrorToErrors));
				}
			}
		}
		if (errors.length > 0) {
			// Errors on preloader functions are not meant to break anything.
			// But we still want to know them...
			// eslint-disable-next-line no-console
			console.error('Errors caught by waitForAllReturnWhenError', {
				errors: errors.map((error) => error.message),
			});
			return errors;
		}
	});
}
